module.exports = __webpack_public_path__ + "img/bg-8.ff7fec41.jpg";